import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { browserHistory } from "react-router";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import { ChargeTemplateCreate } from "../../Partials/Dialog/ChargeTemplateCreate";
import { ChargeTemplateUpdate } from "../../Partials/Dialog/ChargeTemplateUpdate";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";

class UnitDefaultChargeTemplates extends Component {
  private unit: UnitInterface;

  public state = {
    unitId: 0,
    isUpdating: false,
    nextPath: "",

    // charge templates
    isChargeTemplatePopupOpen: true,
    anchorElChargeTemplate: null,
    selectedChargeTemplate: null
  };

  constructor(public props) {
    super(props);

    const url = browserHistory.getCurrentLocation().pathname;
    let pos = url.indexOf("unit/") + 5;
    const stringWithEnd = url.slice(pos);
    pos = stringWithEnd.indexOf("/");
    const unitId = stringWithEnd.slice(0, pos);
    this.state.unitId = +unitId;

    this.unit = this.props.units.byId[this.state.unitId];

    this.done = this.done.bind(this);
  }

  public openChargeTemplateCreatePopup = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR,
    });

    this.setState({
      isChargeTemplatePopupOpen: true
    });
  }

  public closeChargeTemplatePopup = () => {
    this.setState({
      isChargeTemplatePopupOpen: false,
      selectedChargeTemplate: null,
      isUpdating: false
    });
  }

  public openChargeTemplateMenu = (event: any, chargeTemplate: ChargeTemplateInterface): void => {
    this.setState({
      selectedChargeTemplate: chargeTemplate,
      anchorElChargeTemplate: event.currentTarget
    });
  }

  public closeChargeTemplateMenu = (): void => {
    this.setState({
      anchorElChargeTemplate: null
    });
  }

  public addChargeTemplate = (chargeTemplate): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_START,
      payload: {
        chargeTemplate: chargeTemplate,
        unitId: this.unit.id
      },
      onSuccess: () => {
        this.closeChargeTemplatePopup();
      }
    });
  }

  public openChargeTemplateUpdatePopup = (chargeTemplate: ChargeTemplateInterface): any => {
    this.setState({
      selectedChargeTemplate: chargeTemplate,
      isUpdating: true,
      anchorElChargeTemplate: null,
      isChargeTemplatePopupOpen: true
    });
  }

  public updateChargeTemplate = (updatedChargeTemplate: ChargeTemplateInterface): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_START,
      payload: {
        chargeTemplate: updatedChargeTemplate
      },
      onSuccess: () => {
        this.closeChargeTemplatePopup();
      }
    });
  }

  public deleteChargeTemplate = (chargeTemplate: ChargeTemplateInterface): any => {
    this.closeChargeTemplateMenu();

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_DELETE_START,
      payload: {
        chargeTemplate: chargeTemplate
      }
    });
  }

  public getChargeTemplatePopupTitle = () => {
    if (this.state.isUpdating) {
      return this.trans("dialog/defaultchargetemplatesdetails-title")
    } else {
      return this.trans("dialog/newdefaultchargetemplates-title")
    }
  }

  public getChargeTemplatePopupContent = (): any => {
    if (this.state.isUpdating) {
      return (
        <ChargeTemplateUpdate
          {...this.props}
          entity={"unit"}
          chargeTemplate={this.state.selectedChargeTemplate}
          onSave={this.updateChargeTemplate}
          onCancel={this.closeChargeTemplatePopup}
          hideDateFields={true}
          chargeTypes={TypeContainer.getChargeTypesForChargeTemplates("unit")}
        />
      );
    }

    return (
      <ChargeTemplateCreate
        {...this.props}
        entity={"unit"}
        selectedType={TypeContainer.pickIdFromLabel("Basic_rent")}
        onSave={this.addChargeTemplate}
        onCancel={this.closeChargeTemplatePopup}
        chargeTypes={TypeContainer.getChargeTypesForChargeTemplates("unit")}
        firstDate={null}
      />
    );
  }

  public comparer = (a, b) => {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  }

  public chargeTemplateComparer = (a, b) => {
    return this.comparer(a.repeatPeriod.id, b.repeatPeriod.id) ||
      this.comparer(a.type.label, b.type.label);
  }

  public getDefaultChargeTemplates = () => {
    return [...this.unit.defaultChargeTemplates]
      .filter((chargeTemplate: ChargeTemplateInterface) => !!chargeTemplate)
      .sort(this.chargeTemplateComparer)
      .map((chargeTemplate: ChargeTemplateInterface) => {
        return (
          <TableRow
            hover
            key={chargeTemplate.id}
            className={`clickable-entity`}
            onClick={() => {
              this.openChargeTemplateUpdatePopup(chargeTemplate);
            }}
          >
            <TableCell></TableCell>
            <TableCell style={{width: "24px", paddingLeft: "10px", paddingRight: "5px"}}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
                <div
                  className="icon icon-ic-charge"
                >
                </div>
              </div>
            </TableCell>
            <TableCell>
              {this.formatter.formatNumber(chargeTemplate.amount, chargeTemplate.currency)}
            </TableCell>
            <TableCell>{this.formatter.checkTranslationType(this.trans(chargeTemplate?.type?.label, {}, "", chargeTemplate?.type?.system), chargeTemplate?.type?.label, chargeTemplate?.type?.system)}</TableCell>
            <TableCell>{this.formatter.checkTranslationType(this.trans(chargeTemplate.repeatPeriod.label), chargeTemplate.repeatPeriod.label)}</TableCell>
            <TableCell>{chargeTemplate?.isPaidDirectlyToOwner ? this.trans("label-direct") : ""}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openChargeTemplateMenu(e, chargeTemplate)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElChargeTemplate}
                  open={Boolean(this.state.anchorElChargeTemplate) && this.state.selectedChargeTemplate && this.state.selectedChargeTemplate.id === chargeTemplate.id}
                  onClose={this.closeChargeTemplateMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.openChargeTemplateUpdatePopup(this.state.selectedChargeTemplate)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={() => this.deleteChargeTemplate(this.state.selectedChargeTemplate)}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public done = () => {
    return this.setState({
      nextPath: `/app/contract/create/${this.props.app.personIdForCreatingContract}/${this.unit.id}`
    }, this.redirectBack)
  }

  public componentWillUnmount() {
    if(this.state.nextPath) {
      this.redirect(this.state.nextPath);
    }
  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full component-finance full-width has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper" style={{width: "100%"}}>
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{`${this.trans("create-default-price-for")} ${this.unit.displayName}`}</h1>
              <div className="button-container">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.done}
                >
                  {this.trans("label-done")}
                </Button>
              </div>
            </div>
          </div>

          <div className="component-wrapper no-margin-top">
            <Card className="card no-padding">
                <div className="label-container">
                <h3 className="card-title">
                    {this.trans("section/defaultunitchargetemplates-title")}
                </h3>

                <Button
                  color="primary"
                  onClick={this.openChargeTemplateCreatePopup}
                >
                  {this.trans("section/defaultunitchargetemplates-button/newprice")}
                </Button>

                <PromptDialog
                  {...this.props}
                  title={this.getChargeTemplatePopupTitle()}
                  content={this.getChargeTemplatePopupContent()}
                  openLeavePrompt={this.state.isChargeTemplatePopupOpen}
                  onClose={this.closeChargeTemplatePopup}
                  onlyPositiveButton={false}
                  prioritizeClosing={true}
                  withoutDefaultDilaogButtons={true}
                />

                </div>
                <div>
                <TableComponent
                  {...this.props}
                  entities={this.unit.defaultChargeTemplates}
                  className="listing-table"
                  subtitle={this.trans("no-default-charges-to-list")}
                  rows={this.getDefaultChargeTemplates()}
                />
                </div>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    units: state.units,
    component: state.unitDefaultChargeTemplates,
    chargeTemplateCreate: state.chargeTemplateCreate,
    chargeTemplateUpdate: state.chargeTemplateUpdate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
    UnitDefaultChargeTemplates
);
